/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  FC,
  PropsWithChildren,
  useCallback,
  useEffect,
  useState,
} from 'react';

import classNames from 'classnames';

import styles from './TextTabs.module.css';

type Item = {
  title: string;
  text: string;
  imageUrl?: string;
};

type Props = PropsWithChildren<{
  items: Array<Item>;
  defaultIndex?: number;
  onChange?: (index: number) => void;
}>;

export const TextTabs: FC<Props> = ({
  children,
  items,
  defaultIndex = 0,
  onChange,
}) => {
  const [selectedItemIndex, setSelectedItemIndex] = useState(defaultIndex);

  const tabChangeHandler = useCallback(
    (index: number) => {
      setSelectedItemIndex(index);
      if (onChange) onChange(index);
    },
    [setSelectedItemIndex, onChange],
  );

  useEffect(() => {
    if (defaultIndex !== selectedItemIndex) {
      setSelectedItemIndex(defaultIndex);
    }
  }, [defaultIndex]);

  return (
    <div className={styles.container}>
      <div className={styles.button_wrapper}>
        {items.map((item, index) => (
          <button
            key={item.title}
            type="button"
            className={classNames(
              styles.button,
              selectedItemIndex === index && styles.button_selected,
            )}
            onClick={() => tabChangeHandler(index)}
          >
            {item.title}
          </button>
        ))}
      </div>
      <div className={classNames(styles.text)}>
        {items[selectedItemIndex].text}
      </div>
      <div className={styles.image_wrapper}>
        {items.map((i, key) => {
          return (
            <img
              key={i.imageUrl}
              className={classNames(styles.image_small, {
                [styles.image_small_active]: selectedItemIndex === key,
              })}
              loading="lazy"
              src={i.imageUrl}
              alt="tab"
            />
          );
        })}
      </div>

      <div className={classNames(styles.content)}>{children}</div>
    </div>
  );
};
